import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/Meta'
import Builder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import usePagePrecache from '@/hooks/usePagePrecache'
// import { mapPageStaticProps } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'

import { WPPageData } from '@/types'

export default function Home(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, [])
  return (
    <>
      <div data-builder className="relative z-10">
        <Builder pageData={pageData} />
      </div>
    </>
  )
}

Home.getLayout = function getLayout(page: ReactElement, props: WPPageData) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  locale,
  defaultLocale
}: GetStaticPropsContext<{ routes: string[] }>) {
  const { data: pageData } = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale !== defaultLocale ? locale : ''}`
  })

  if (!pageData) return { notFound: true }

  return {
    props: {
      ...pageData
    }
  }
}
